import script from "./LeadsPageSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadsPageSettings.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__